module.exports = __webpack_public_path__ + "static/media/cu04.8c5c4417.png";